import Select, { OptionList, SelectHandle, SelectOption } from '@/ui/select'
import classNames from 'classnames'
import React, { ReactNode } from 'react'

export function SelectLine<Option extends SelectOption>({
  id,
  options,
  renderOption,
  onChange,
  children,
  disabled
}: {
  id: Option['id'] | undefined
  options: OptionList<Option>
  renderOption?: (opt: Option, search?: RegExp) => ReactNode
  onChange: (opt: Option | undefined) => void
  children: (expanded: boolean) => ReactNode
  disabled?: boolean
}) {
  const [expanded, setExpanded] = React.useState(false)

  const onClick = React.useCallback(
    (e: React.MouseEvent) => {
      if (!expanded && !(e.target as HTMLElement).closest('.poe-HoverNumber, input, .ui-Select')) {
        setExpanded(true)
      }
    },
    [expanded]
  )

  const selectRef = React.useRef<SelectHandle>(null)
  React.useEffect(() => {
    if (expanded && !disabled && selectRef.current) {
      selectRef.current.focus()
    }
  }, [expanded, disabled])
  const onClose = React.useCallback(() => setExpanded(false), [])

  const contents = React.useMemo(
    () => (
      <div
        className={classNames('poe-stat-contents', {
          'poe-expandable': !disabled
        })}
        onClick={onClick}>
        {children(expanded)}
      </div>
    ),
    [onClick, expanded, children, disabled]
  )

  return expanded && !disabled ? (
    <Select
      options={options}
      renderValue={() => contents}
      placeholder={contents}
      renderOption={renderOption}
      value={id != null ? ({ id, name: '' } as Option) : undefined}
      onChange={onChange}
      searchLimit={10}
      searchMiddle={true}
      className="ui-Select poe-ModSelect"
      valueClass="ui-Select-value"
      menuClass="ui-Select-menu"
      optionClass="ui-Select-option"
      ref={selectRef}
      onClose={onClose}
      virtualScroll
    />
  ) : (
    contents
  )
}
